import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg';
import AccountRow from '../AccountRow/AccountRow';
import { AccountsContext } from '../../contexts/AccountsContext';
import useSmallDevice from '../../hooks/useSmallDevice';
import styles from './style.cssmodule.css';

function AccountsTable() {
  const {
    accounts, accountsLoading, filters, dispatchFilters,
  } = useContext(AccountsContext);
  const { formatMessage: t } = useIntl();
  const { isSmallDevice } = useSmallDevice();

  if (!accounts && !accountsLoading) return null;

  const initialLoading = !accounts && accountsLoading;
  const InitialLoadingBar = accountsLoading && (
  <div
    className={styles.loadingTable}
  />
  );

  const fields = [
    {
      name: 'username', label: t({ id: 'table.header.account.username' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'email', label: t({ id: 'table.header.account.email' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'phoneNumber', label: t({ id: 'table.header.account.phoneNumber' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'address', label: t({ id: 'table.header.account.address' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'totalAccesses', label: t({ id: 'table.header.account.totalAccesses' }), labelMini: t({ id: 'table.header.account.total' }), additionalStyle: {},
    },
    {
      name: 'activeAccesses', label: t({ id: 'table.header.account.activeAccesses' }), labelMini: t({ id: 'table.header.account.active' }), additionalStyle: {},
    },
    {
      name: 'carparksLinked', label: t({ id: 'table.header.account.carparksLinked' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'status', label: t({ id: 'table.header.account.status' }), labelMini: null, additionalStyle: {},
    },
    {
      name: 'actions', label: t({ id: 'table.header.account.actions' }), labelMini: null, additionalStyle: { textAlign: 'center' },
    },
  ];

  const TableHeader = (
    <thead style={{ position: 'relative' }}>
      <tr>
        {fields.map(({
          name, label, labelMini, additionalStyle,
        }) => {
          const isSortable = name in filters && 'sort' in filters[name] && accounts.length > 1;
          const isSortedAsc = isSortable && filters[name].sort === 'ASC';
          const isSortedDesc = isSortable && filters[name].sort === 'DESC';
          const canBeSorted = isSortedAsc || isSortedDesc;
          const toggleSort = isSortable ? () => dispatchFilters({ type: 'TOGGLE_FILTER_SORT', filter: name }) : null;

          return (
            <th
              key={name}
              onClick={toggleSort}
              style={additionalStyle}
              className={isSortable ? styles.sortable : ''}
              data-type={name}
            >
              <div className={styles.headerContent}>
                <span>{(isSmallDevice && labelMini) ? labelMini : label}</span>
                {canBeSorted && (
                  <ArrowIcon
                    style={{
                      transform: isSortedAsc ? 'rotate(-180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                )}
              </div>
            </th>
          );
        })}
      </tr>
      {InitialLoadingBar}
    </thead>
  );

  return (
    <table className={styles.table}>
      {TableHeader}
      <tbody>
        {initialLoading
          ? <AccountRow account={{ showSkeleton: true }} />
          : accounts.map((account) => (
            <AccountRow key={account.id} account={account} />
          ))}
      </tbody>
    </table>
  );
}

export default AccountsTable;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/AccountsTable/AccountsTable.jsx